module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [(_vm.showNewButton) ? _c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "CRM Follow-up",
      "visible": _vm.addDisplayBasic,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      },
      "show": _vm.checkNepaliDateOrEnglish
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": "Manage Remarks",
            "icon": "pi pi-comments"
          },
          on: {
            "click": _vm.openRemarksDialog
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addFollowUpDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewFollowUpDetails.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "particular"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "particular"
    },
    model: {
      value: (_vm.particular),
      callback: function($$v) {
        _vm.particular = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "particular"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client Name "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "clientName"
    },
    model: {
      value: (_vm.clientName),
      callback: function($$v) {
        _vm.clientName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clientName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "contactPerson"
    }
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactPerson"
    },
    model: {
      value: (_vm.contactPerson),
      callback: function($$v) {
        _vm.contactPerson = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactPerson"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "province"
    }
  }, [_vm._v("Province")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "province",
      "options": _vm.provinceList,
      "optionLabel": "name",
      "optionValue": "name",
      "placeholder": "Select Province"
    },
    on: {
      "change": _vm.updateDistrictList
    },
    model: {
      value: (_vm.selectedProvince),
      callback: function($$v) {
        _vm.selectedProvince = $$v
      },
      expression: "selectedProvince"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v("District")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "district",
      "options": _vm.filteredDistricts,
      "optionLabel": "name",
      "optionValue": "name",
      "placeholder": "Select District",
      "disabled": !_vm.selectedProvince
    },
    model: {
      value: (_vm.selectedDistrict),
      callback: function($$v) {
        _vm.selectedDistrict = $$v
      },
      expression: "selectedDistrict"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "contactNumber"
    }
  }, [_vm._v("Contact Number "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactNumber",
      "maxlength": "10"
    },
    on: {
      "input": _vm.validateContactNumber
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "secondaryContactNumber"
    }
  }, [_vm._v("Secondary Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "secondaryContactNumber",
      "maxlength": "10"
    },
    on: {
      "input": _vm.validateSeconContactNumber
    },
    model: {
      value: (_vm.secondaryContactNumber),
      callback: function($$v) {
        _vm.secondaryContactNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "secondaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "gmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "gmail"
    },
    model: {
      value: (_vm.gmail),
      callback: function($$v) {
        _vm.gmail = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "gmail"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "product"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('MultiSelect', {
    staticStyle: {
      "height": "36px !important",
      "min-height": "36px !important"
    },
    attrs: {
      "id": "product",
      "options": _vm.productList,
      "optionLabel": "name",
      "placeholder": "Select Products",
      "showCheckbox": true,
      "filter": true
    },
    on: {
      "filter": _vm.searchProducts
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-multiselect-item-option"
        }, [_c('span', [_vm._v(_vm._s(slotProps.option.name))])])]
      }
    }]),
    model: {
      value: (_vm.selectedProducts),
      callback: function($$v) {
        _vm.selectedProducts = $$v
      },
      expression: "selectedProducts"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "rate"
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "customerType"
    }
  }, [_vm._v("Customer Type"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "customerType",
      "options": _vm.filteredCustomerTypes,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Select Customer Type"
    },
    model: {
      value: (_vm.customerType),
      callback: function($$v) {
        _vm.customerType = $$v
      },
      expression: "customerType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "priority"
    }
  }, [_vm._v("Priority")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "priority",
      "options": _vm.priorityList,
      "optionLabel": "value",
      "optionValue": "value",
      "placeholder": "Select Priority"
    },
    model: {
      value: (_vm.priority),
      callback: function($$v) {
        _vm.priority = $$v
      },
      expression: "priority"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "stage"
    }
  }, [_vm._v("Stage")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "stage",
      "options": _vm.stageList,
      "optionLabel": "value",
      "optionValue": "value",
      "placeholder": "Select Stage"
    },
    model: {
      value: (_vm.selectedStage),
      callback: function($$v) {
        _vm.selectedStage = $$v
      },
      expression: "selectedStage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "soldfrom"
    }
  }, [_vm._v("Sold From Type"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "soldfrom",
      "options": _vm.soldFromLists,
      "optionLabel": "label",
      "optionValue": "value",
      "placeholder": "Select Sold From"
    },
    model: {
      value: (_vm.soldFrom),
      callback: function($$v) {
        _vm.soldFrom = $$v
      },
      expression: "soldFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "commission",
      "binary": true
    },
    model: {
      value: (_vm.commission),
      callback: function($$v) {
        _vm.commission = $$v
      },
      expression: "commission"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-checkbox-label",
    attrs: {
      "for": "commission"
    }
  }, [_vm._v("Commission")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "sampleQuotationSent",
      "binary": true
    },
    model: {
      value: (_vm.sampleQuotationSent),
      callback: function($$v) {
        _vm.sampleQuotationSent = $$v
      },
      expression: "sampleQuotationSent"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-checkbox-label",
    attrs: {
      "for": "sampleQuotationSent"
    }
  }, [_vm._v("Sample Sent")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', [_vm._v("Sample Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "sam",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.sampleSentDate),
      callback: function($$v) {
        _vm.sampleSentDate = $$v
      },
      expression: "sampleSentDate"
    }
  }) : _c('input-mask', {
    ref: "sam",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "sampleSentDate"
    },
    model: {
      value: (_vm.sampleSentDate),
      callback: function($$v) {
        _vm.sampleSentDate = $$v
      },
      expression: "sampleSentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "callNotReceived",
      "binary": true
    },
    model: {
      value: (_vm.callNotReceived),
      callback: function($$v) {
        _vm.callNotReceived = $$v
      },
      expression: "callNotReceived"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-checkbox-label",
    attrs: {
      "for": "callNotReceived"
    }
  }, [_vm._v("Call Not Received")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('div', {
    staticClass: "p-field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "quotationSent",
      "binary": true
    },
    model: {
      value: (_vm.quotationSent),
      callback: function($$v) {
        _vm.quotationSent = $$v
      },
      expression: "quotationSent"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-checkbox-label",
    attrs: {
      "for": "quotationSent"
    }
  }, [_vm._v("Quotation Sent")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', [_vm._v("Quotation Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "qot",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.quotationSentDate),
      callback: function($$v) {
        _vm.quotationSentDate = $$v
      },
      expression: "quotationSentDate"
    }
  }) : _c('input-mask', {
    ref: "qot",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "quotationSentDate"
    },
    model: {
      value: (_vm.quotationSentDate),
      callback: function($$v) {
        _vm.quotationSentDate = $$v
      },
      expression: "quotationSentDate"
    }
  })], 1)])])], 1), _vm._v(" "), _c('RemarksDialog', {
    attrs: {
      "visible": _vm.remarksDialogVisible,
      "initialRemarks": {
        remarks: _vm.remarks,
        remarks1: _vm.remarks1,
        remarks2: _vm.remark2,
        followUpTime: _vm.followUpTime,
        nextFollowUpDate: _vm.nextFollowUpDate
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.remarksDialogVisible = $event
      },
      "save": _vm.saveRemarks
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61d380b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmFollowUpDetailsDialog.vue
// module id = 2271
// module chunks = 0